import React, { FC } from 'react';
import { Link } from 'src/components/Inputs';

interface Props {
  href: string;
  label: string;
}

const AvailableLanguageLink: FC<Props> = ({ href, label }) => {
  return (
    <li>
      <p>
        <Link href={href}>
          <a data-smooth-scroll data-offset='80'>
            {label}
          </a>
        </Link>
      </p>
    </li>
  );
};

export default AvailableLanguageLink;
